import { browser } from '$app/environment';
import { page } from '$app/stores';
import { derived, get, readable } from 'svelte/store';

const getHashPure = (hash: string) => (hash.startsWith('#') ? hash.slice(1) : hash);

export const getHashStore = () => {
    if (!browser) return readable('');
    let lastHash: string | undefined = get(page).url.hash;
    return derived<typeof page, string>(
        page,
        ($page, set) => {
            if ($page.url.hash !== lastHash) {
                lastHash = $page.url.hash;
                set(getHashPure(lastHash));
            }
        },
        getHashPure(lastHash)
    );
};

export default getHashStore;
